import { useUpdateShipments } from "../../../../utils/hooks/commonly-stored/uploaded-board/updates/shipments";
import { ShipmentsRow } from "./ShipmentsStyles";
import { InputLabel } from "../../../../constants/Styles";
import NumberInput from "../../../common/NumberInput";
import FlashPCBDatePicker from "../../../common/FlashPCBDatePicker";
import React, { useCallback, useState } from "react";
import {
  Board,
  LeadTimeDays,
  Shipment,
} from "../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import Button from "../../../common/Button";
import LoadingOverlay from "../../../LoadingOverlay";
import useShipmentsFromContext from "../../../../utils/hooks/commonly-stored/uploaded-board/shipments";
import { ErrorText } from "../QuoteHistory/QuoteHistoryStyles";

export default function AddOrEditShipment({
  onUpdate,
  shipmentId,
}: {
  onUpdate: () => void;
  shipmentId?: string;
}) {
  const { addShipment, addingShipment, updateShipmentDetails } =
    useUpdateShipments();
  const board = useBoardFromContext().board as Board;
  const shipments = useShipmentsFromContext(board.id) as Shipment[];
  const lastShipment = shipmentId
    ? (shipments.find((shipment) => shipment.id == shipmentId) as Shipment)
    : (shipments.at(-1) as Shipment);
  const [numBoards, setNumBoards] = useState(lastShipment.num_boards);
  const [shipDate, setShipDate] = useState<string | null>(
    lastShipment.ship_date,
  );
  const [baseDays, setBaseDays] = useState<LeadTimeDays>(
    lastShipment.base_lead_time_days,
  );
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null,
  );

  const handleShipDateUpdate = useCallback(
    (shipDate: string | null) => {
      if (shipDate !== null) {
        const leadTimeOption =
          lastShipment.lead_time_options.options.toReversed().find((option) => {
            return (option.ship_date as string) <= shipDate;
          }) || lastShipment.lead_time_options.options[0]!;
        setBaseDays(leadTimeOption.base_days);
        setShipDate(shipDate);
      }
    },
    [lastShipment.lead_time_options.options],
  );

  const handleUpdateShipment = () => {
    if (!numBoards) {
      setValidationMessage("Number of boards must be a positive number.");
    } else if (shipDate === null) {
      setValidationMessage("Ship date must be set");
    } else if (shipmentId) {
      updateShipmentDetails(
        shipmentId,
        {
          num_boards: numBoards,
          ship_date: shipDate,
          base_lead_time_days: baseDays,
        },
        onUpdate,
      );
    } else {
      addShipment(
        {
          num_boards: numBoards,
          ship_date: shipDate,
          base_lead_time_days: baseDays,
        },
        onUpdate,
      );
    }
  };

  return (
    <>
      <LoadingOverlay loading={addingShipment} text={"Updating shipment..."} />
      {validationMessage && <ErrorText>{validationMessage}</ErrorText>}
      <ShipmentsRow>
        <div>
          <InputLabel>Number of boards</InputLabel>
          <NumberInput
            name="number of boards"
            value={numBoards}
            onChange={(newValue) => {
              setNumBoards(newValue);
            }}
            min={0}
          />
        </div>
        <div>
          <InputLabel>Ship date</InputLabel>
          <FlashPCBDatePicker
            leadTimeOptions={lastShipment.lead_time_options}
            selectedLeadTime={null}
            selectedDate={shipDate}
            setSelectedDate={handleShipDateUpdate}
          />
        </div>
        <Button
          label={"Save"}
          onClick={handleUpdateShipment}
          disabled={shipDate === null || numBoards === 0}
        />
      </ShipmentsRow>
    </>
  );
}
